if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.preorderPropertyInput = this.form.querySelector('[data-preorder-property]');
        this.preorderIncomingDatePropertyInput = this.form.querySelector('[data-preorder-incoming-date-property]');
        this.preorderNote = this.form.querySelector('[data-preorder-note]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // カート追加成功時はポップアップを表示
            this.showCartNotification(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updateSubmitButtonForVariant(variant) {
        if (!variant) {
          this.toggleSubmitButton(true, window.variantStrings.unavailable);
          this.updatePreorderProperties(false);
          this.updatePreorderNote(false);
          return;
        }

        const isPreorder =
          Number(variant.inventory_quantity || 0) <= 0 &&
          variant.inventory_policy === 'continue';
        const incomingDate =
          isPreorder && variant.incoming && variant.next_incoming_date
            ? this.formatJapaneseIncomingDate(variant.next_incoming_date)
            : '';

        let buttonText = window.variantStrings.addToCart;
        let disabled = false;

        if (isPreorder) {
          buttonText =
            variant.incoming && variant.next_incoming_date && incomingDate
              ? `予約注文（${incomingDate}入荷予定）`
              : '予約注文';
        } else if (!variant.available) {
          buttonText = window.variantStrings.soldOut;
          disabled = true;
        }

        this.submitButton.toggleAttribute('disabled', disabled);
        this.submitButtonText.textContent = buttonText;
        this.updatePreorderProperties(isPreorder, variant.next_incoming_date);
        this.updatePreorderNote(isPreorder, incomingDate);
      }

      formatJapaneseIncomingDate(dateString) {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) return '';

        return `${date.getMonth() + 1}月${date.getDate()}日`;
      }

      formatIncomingDateProperty(dateString) {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) return '';

        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
      }

      updatePreorderProperties(isPreorder, nextIncomingDate = '') {
        if (this.preorderPropertyInput) {
          this.preorderPropertyInput.disabled = !isPreorder;
        }

        if (this.preorderIncomingDatePropertyInput) {
          const propertyDate = isPreorder ? this.formatIncomingDateProperty(nextIncomingDate) : '';
          this.preorderIncomingDatePropertyInput.value = propertyDate;
          this.preorderIncomingDatePropertyInput.disabled = !propertyDate;
        }
      }

      updatePreorderNote(isPreorder, incomingDate = '') {
        if (!this.preorderNote) return;

        this.preorderNote.textContent = incomingDate
          ? `こちらの商品は予約注文商品です。${incomingDate}入荷後、順次発送いたします。`
          : 'こちらの商品は予約注文商品です。入荷後、順次発送いたします。';
        this.preorderNote.hidden = !isPreorder;
      }

      showCartNotification(response) {
        // modal.jsを使用してモーダルを表示
        const item = response;
        if (!item) return;

        let variantData = null;
        const selectedVariantScript =
          this.closest('product-info')?.querySelector('variant-selects [data-selected-variant]') ||
          document.querySelector('variant-selects [data-selected-variant]');
        if (selectedVariantScript) {
          try {
            variantData = JSON.parse(selectedVariantScript.textContent);
          } catch (e) {
            console.error('Failed to parse variant data:', e);
          }
        }

        // 商品情報を挿入
        const image = document.querySelector('[data-notification-image]');
        const name = document.querySelector('[data-notification-name]');
        const variant = document.querySelector('[data-notification-variant]');
        const price = document.querySelector('[data-notification-price]');

        if (image && item.featured_image) {
          image.src = item.featured_image.url;
          image.alt = item.product_title;
        }
        if (name) name.textContent = item.product_title;
        if (variant && item.variant_title && item.variant_title !== 'Default Title') {
          variant.textContent = item.variant_title;
        } else if (variant) {
          variant.textContent = '';
        }
        if (price) {
          const comparePrice = document.querySelector('[data-notification-compare-price]');
          const saleLabel = document.querySelector('[data-notification-sale-label]');
          const currentPrice = price;
          
          // variantDataからcompare_at_priceを取得（なければitemから）
          const compareAtPrice = variantData?.compare_at_price || item.compare_at_price;
          const itemPrice = item.price;
          
          // セール判定
          const isOnSale = compareAtPrice && compareAtPrice > itemPrice;
          
          // 比較価格の表示/非表示
          if (comparePrice) {
            if (isOnSale) {
              comparePrice.innerHTML = window.formatPrice(compareAtPrice);
              comparePrice.style.display = 'inline';
            } else {
              comparePrice.style.display = 'none';
            }
          }
          
          // SALEラベルの表示/非表示
          if (saleLabel) {
            saleLabel.style.display = isOnSale ? 'inline' : 'none';
          }
          
          // 現在価格の表示
          currentPrice.innerHTML = window.formatPrice(itemPrice);
          if (isOnSale) {
            currentPrice.classList.add('price__current--on-sale');
          } else {
            currentPrice.classList.remove('price__current--on-sale');
          }
        }

        // modal.jsを使用してモーダルを開く
        if (window.modalSystem) {
          window.modalSystem.open('cart-added-modal');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
